import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SCREENING_CONFIG_API_SERVICE_TOKEN } from '@nk/api-lib';
import { AddToScreeningFormValue, EntityMonitoringTypeEntity } from '@nk/data-entities-lib';
import { SpinnerComponent } from '@nk/ui-lib';
import { checkControlValid, FormControls } from '@nk/utils-lib';
import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { ENTITY_MONITORING_TYPE_TRANSLATIONS } from '../../utils/screening.utils';

@Component({
  selector: 'nk-add-to-screening-form',
  imports: [TranslateModule, ReactiveFormsModule, SpinnerComponent, AsyncPipe],
  templateUrl: './add-to-screening-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddToScreeningFormComponent implements OnInit {
  @Input() public entityMonitoringTypeUuid: string | undefined;
  @Output() public valueChanged = new EventEmitter<AddToScreeningFormValue>();
  @Output() public formValidityChanged = new EventEmitter<boolean>();
  public monitoringTypes$!: Observable<EntityMonitoringTypeEntity[]>;
  public form = new FormGroup<FormControls<AddToScreeningFormValue>>({
    entity_monitoring_type_uuid: new FormControl('', [Validators.required]),
    monitoring_comment: new FormControl('', [Validators.required]),
  });
  public entityMonitoringTypeTranslations = ENTITY_MONITORING_TYPE_TRANSLATIONS;
  private _screeningConfigService = inject(SCREENING_CONFIG_API_SERVICE_TOKEN);
  private _destroy = inject(DestroyRef);

  public isControlValid(key: keyof AddToScreeningFormValue): boolean {
    return checkControlValid(this.form, key);
  }

  public ngOnInit(): void {
    this.monitoringTypes$ = this._screeningConfigService.entityMonitoringTypeListCache.get();

    if (this.entityMonitoringTypeUuid) {
      this.form.patchValue({
        entity_monitoring_type_uuid: this.entityMonitoringTypeUuid,
      });
    }

    this.form.statusChanges.pipe(startWith(''), takeUntilDestroyed(this._destroy)).subscribe((status) => {
      this.formValidityChanged.next(status === 'VALID');
    });

    this.form.valueChanges.pipe(takeUntilDestroyed(this._destroy)).subscribe((data) => {
      this.valueChanged.next(data as AddToScreeningFormValue);
    });
  }
}
